/*
 * Black Friday promo for Dawn 15.x
 * - Free shipping / free gift progress bar in the cart drawer and cart page
 * - Auto-adds this week's $0 gift product when the cart qualifies, removes it when it doesn't
 * - Non-blocking popup (Esc / outside click / X / OK, no timed close) whenever the gift is added, removed or swapped
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('bf-promo-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[bf-promo] bad config', e); return; }

  var RATE = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var IS_CART_PAGE = /\/cart\/?$/.test(window.location.pathname);
  var STATE_KEY = 'bfGiftInCart';   // variant id we last saw in the cart
  var BOGO_KEY = 'bfBogoQty';       // last seen quantity of each BOGO variant
  // ---- Easy-to-edit wording ----
  // Short gift name for the cart bar, per week (empty = use the gift product's name)
  var GIFT_SHORT = { 1: 'Matcha Sifter/ Strainer', 2: '', 3: '', 4: '' };
  // Your Black Friday page: used by "GET MY FREE GIFT" in the popup and "Continue shopping" in the empty cart
  var GIFT_CTA_URL = '/pages/black-friday-sale';
  var GIFT_CTA_TEXT = 'GET MY FREE GIFT \u2192';

  var DECLINE_KEY = 'bfGiftDeclined'; // variant id the customer removed on purpose

  var giftIds = cfg.weeks.map(function (w) { return w.variantId; }).filter(Boolean);
  var lastCart = null;
  var busy = false;
  var rerun = false;

  /* ---------- helpers ---------- */

  function store(key, val) {
    try {
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, String(val));
    } catch (e) { /* storage blocked: fine */ }
  }
  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function toCents(amount) { return Math.round(Number(amount) * 100 * RATE); }

  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    var withDec = value.toFixed(2);
    var noDec = String(Math.ceil(value));
    function commas(s, sep, dec) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return commas(noDec, ',', '.');
        case 'amount_with_comma_separator': return commas(withDec, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return commas(noDec, '.', ',');
        default: return commas(withDec, ',', '.');
      }
    });
  }

  // Which campaign week is it, regardless of whether a gift is set. Drives site-wide deal badges.
  function campaignWeek() {
    var p = cfg.preview;
    if (p === 'off') return null;
    if (/^[1-4]$/.test(p)) return Number(p);
    var now = Date.now();
    if (cfg.end && Date.parse(cfg.end) <= now) return null;
    var best = null, bestStart = -Infinity;
    cfg.weeks.forEach(function (w) {
      var t = Date.parse(w.start);
      if (!isNaN(t) && t <= now && t >= bestStart) { best = w.week; bestStart = t; }
    });
    return best;
  }
  function markWeek() {
    var w = campaignWeek();
    document.documentElement.setAttribute('data-bf-week', w ? String(w) : 'none');
  }
  markWeek();
  setInterval(markWeek, 60000);

  function activeWeek() {
    var p = cfg.preview;
    if (p === 'off') return null;
    if (/^[1-4]$/.test(p)) {
      var forced = cfg.weeks[Number(p) - 1];
      return forced && forced.variantId ? forced : null;
    }
    var now = Date.now();
    if (cfg.end && Date.parse(cfg.end) <= now) return null;
    var active = null;
    cfg.weeks.forEach(function (w) {
      var start = Date.parse(w.start);
      if (w.variantId && start <= now && (!active || start >= Date.parse(active.start))) active = w;
    });
    return active;
  }

  function isGift(item) {
    return giftIds.indexOf(item.variant_id) !== -1 || (item.properties && item.properties._bf_gift);
  }

  // Gift cards never count toward promo thresholds. The store's gift card is a
  // regular product (type "Gift Cards"), so i.gift_card alone is false for it.
  function isGiftCard(item) {
    return !!item.gift_card || item.handle === 'paragon-gift-card' || /^gift cards?$/i.test(item.product_type || '');
  }

  // Totals in cents, ignoring gift lines.
  function totals(cart) {
    var before = 0, after = 0;
    cart.items.forEach(function (i) {
      if (isGift(i) || isGiftCard(i)) return;
      before += i.original_line_price;
      after += i.final_line_price;
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      after -= d.total_allocated_amount || 0;
    });
    return { before: before, after: Math.max(after, 0) };
  }

  function t2after(c) { return totals(c).after; }

  function shipThresholdCents() {
    var t = cfg.country === 'US' ? cfg.shipThresholdUS : (cfg.country && cfg.country !== 'CA' && cfg.shipThresholdIntl ? cfg.shipThresholdIntl : cfg.shipThreshold);
    return t ? toCents(t) : null;
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  /* ---------- popup ---------- */

  // message: plain text, or { title, text, cta, url } for a popup with a heading and a link button
  var activePop = null; // open BOGO popup that lists suggestions (Option B)
  // Giftfix: while the cart drawer is open, show a slim notice pinned to the top of the drawer
  // (never over Check out / express pay) that fades out after ~4s.
  function drawerOpen() {
    var cd = document.querySelector('cart-drawer');
    return !!(cd && cd.classList.contains('active'));
  }
  function drawerNotice(m) {
    return new Promise(function (resolve) {
      var cd = document.querySelector('cart-drawer');
      var inner = cd && cd.querySelector('.drawer__inner');
      if (!inner) { resolve(); return; }
      var old = cd.querySelector('.bf-notice'); if (old) old.remove();
      var r = inner.getBoundingClientRect();
      var n = document.createElement('div');
      n.className = 'bf-notice'; n.setAttribute('role', 'status'); n.setAttribute('aria-live', 'polite');
      n.style.left = r.left + 'px'; n.style.width = r.width + 'px';
      var txt = document.createElement('span'); txt.className = 'bf-notice__text';
      txt.textContent = (m.title ? m.title + ' ' : '') + m.text;
      n.appendChild(txt);
      if (m.cta && m.url) { var a = document.createElement('a'); a.className = 'bf-notice__cta'; a.href = m.url; a.textContent = m.cta; n.appendChild(a); }
      var x = document.createElement('button'); x.type = 'button'; x.className = 'bf-notice__x'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '&times;';
      n.appendChild(x);
      cd.appendChild(n); // outside #CartDrawer, so the drawer re-render doesn't wipe it
      requestAnimationFrame(function () { n.classList.add('is-on'); });
      var done = false;
      function close() { if (done) return; done = true; n.classList.remove('is-on'); setTimeout(function () { n.remove(); }, 400); resolve(); }
      x.addEventListener('click', close);
      setTimeout(close, m.cta ? 6000 : 4000);
    });
  }
  function popup(message) {
    var m0 = typeof message === 'string' ? { text: message } : message;
    if (m0 && m0.also && activePop && activePop.isOpen()) { activePop.update(m0); return Promise.resolve(); }
    if (m0 && drawerOpen()) return drawerNotice(m0);
    return new Promise(function (resolve) {
      var d = document.createElement('dialog');
      d.className = 'bf-popup';
      var m = typeof message === 'string' ? { text: message } : message;
      d.innerHTML =
        '<div class="bf-popup__icon" aria-hidden="true">🎁</div>' +
        (m.title ? '<p class="bf-popup__title"></p>' : '') +
        '<p class="bf-popup__msg"></p>' +
        (m.cta
          ? '<a class="button bf-popup__cta"></a><button type="button" class="bf-popup__close bf-popup__ok">Keep shopping</button>'
          : '<button type="button" class="button bf-popup__ok">OK</button>');
      if (m.title) d.querySelector('.bf-popup__title').textContent = m.title;
      d.querySelector('.bf-popup__msg').textContent = m.text;
      if (m.also) { var al = document.createElement('div'); al.className = 'bf-popup__also'; al.hidden = true; d.querySelector('.bf-popup__ok').before(al); }
      if (m.cta) { var a = d.querySelector('.bf-popup__cta'); a.textContent = m.cta; a.href = m.url; }
      // Non-blocking: closes with Esc, a click/tap outside, the X or OK.
      // Opened with show() (not showModal) so the cart drawer and checkout stay clickable.
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'bf-popup__x'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '&times;';
      d.insertBefore(x, d.firstChild);
      var shade = document.createElement('div');
      shade.className = 'bf-popup-shade';
      var done = false, timer;
      function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') close(); }
      function onOutside(e) { if (!d.contains(e.target)) close(); }
      var close = function () {
        if (done) return; done = true;
        clearTimeout(timer);
        document.removeEventListener('keydown', onKey, true);
        document.removeEventListener('pointerdown', onOutside, true);
        try { d.close(); } catch (err) {}
        d.remove(); shade.remove();
        resolve();
      };
      d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      x.addEventListener('click', function () { close(); });
      d.querySelector('.bf-popup__ok').addEventListener('click', function () { close(); });
      document.body.appendChild(shade);
      document.body.appendChild(d);
      if (typeof d.show === 'function') d.show();
      else d.setAttribute('open', '');
      document.addEventListener('keydown', onKey, true);
      setTimeout(function () { if (!done) document.addEventListener('pointerdown', onOutside, true); }, 0);
      // Option B: lists this week's other BOGO items. No timed auto-close:
      // it closes only via the X, a tap outside, Esc or OK, and never blocks the page.
      function renderAlso() {
        var al = d.querySelector('.bf-popup__also');
        if (!al) return;
        var list = lastCart ? upsellList(lastCart) : [];
        var html = list.length ? upsellHTML(list, '<span>Also Buy 1 Get 1</span> this week:') : '';
        if (al.getAttribute('data-html') !== html) { al.innerHTML = html; al.setAttribute('data-html', html); }
        al.hidden = !html;
      }
      function schedule() { renderAlso(); }
      var me = {
        isOpen: function () { return !done; },
        update: function (nm) { if (nm && nm.text) d.querySelector('.bf-popup__msg').textContent = nm.text; schedule(); }
      };
      if (m.also) activePop = me;
      var oldClose = close;
      close = function () { if (activePop === me) activePop = null; oldClose(); };
      schedule();
      // Giftfix: auto-dismiss the card after ~4s (6s when it has a link or suggestions).
      timer = setTimeout(function () { close(); }, (m.cta || m.also) ? 6000 : 4000);
    });
  }

  /* ---------- re-render Dawn's cart UI after we change the cart ---------- */

  function refreshCartUI(cart) {
    if (IS_CART_PAGE) { window.location.reload(); return Promise.resolve(); }
    return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          var current = drawer.querySelector('#CartDrawer');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          drawer.classList.toggle('is-empty', cart.item_count === 0);
        }
        // Product page "Quantity (N in cart)": ask Dawn to refresh it
        document.querySelectorAll('product-info').forEach(function (p) {
          try { if (typeof p.fetchQuantityRules === 'function') p.fetchQuantityRules(); } catch (e) {}
        });
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function (e) { console.warn('[bf-promo] refresh failed', e); });
  }

  /* ---------- progress bar ---------- */

  function line(pct, html, done) {
    return '<div class="bf-bar__goal' + (done ? ' is-done' : '') + '">' +
      '<p class="bf-bar__msg">' + html + '</p>' +
      '<div class="bf-bar__track"><span class="bf-bar__fill" style="width:' + Math.min(100, Math.max(0, pct)) + '%"></span></div>' +
      '</div>';
  }
  function esc(s) { var t = document.createElement('span'); t.textContent = s || ''; return t.innerHTML; }

  /* ---------- Buy 1 Get 1: make every BOGO item come in pairs ---------- */

  function bogoMap() {
    var w = campaignWeek();
    var wk = w ? cfg.weeks[w - 1] : null;
    if (!wk || !wk.bogo) return null;
    var map = {};
    wk.bogo.forEach(function (b) { if (b && b.id) map[b.id] = b; });
    return Object.keys(map).length ? map : null;
  }
  function bogoName(b) { return b.title + (b.size ? ' ' + b.size : ''); }
  function readQty() {
    try { return JSON.parse(read(BOGO_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function bogoQuantities(cart, map) {
    var qty = {}, line = {};
    cart.items.forEach(function (i) {
      if (!map || !map[i.variant_id] || isGift(i)) return;
      qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity;
      if (!line[i.variant_id]) line[i.variant_id] = i;
    });
    return { qty: qty, line: line };
  }

  // One rule everywhere: every BOGO bag you ADD (product page, landing page, quick add)
  // gets a free one. Add 1 -> 2 in cart, add 2 -> 4, add 3 -> 6.
  // In the cart itself the quantity box counts bags, so "+" from 2 to 3 rounds up to 4.
  // If the customer lowers it on purpose, leave it (the bar shows a hint instead).
  var lastSource = '';
  // BOGO lines in the cart: +, - and trash move a whole deal (1 paid + 1 free) at a time.
  // Shopify splits the paid and free bags into two lines, which confuses Dawn's own
  // quantity buttons, so we handle these clicks ourselves.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button, cart-remove-button');
    if (!btn) return;
    var row = btn.closest('tr, .cart-item');
    if (!row || !row.closest('cart-drawer-items, cart-items, cart-drawer')) return;
    var input = row.querySelector('[data-quantity-variant-id]');
    var map = cfg.bogoAuto ? bogoMap() : null;
    if (!input || !map) return;
    var id = Number(input.getAttribute('data-quantity-variant-id'));
    if (!map[id]) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var dir = btn.tagName === 'CART-REMOVE-BUTTON' ? 0 : (btn.getAttribute('name') === 'plus' ? 1 : -1);
    row.style.opacity = '0.5';
    row.style.pointerEvents = 'none';
    setBogoDeals(id, dir);
  }, true);

  function setBogoDeals(id, dir) {
    return getCart().then(function (cart) {
      var lines = cart.items.filter(function (i) { return i.variant_id === id && !isGift(i); });
      var q = lines.reduce(function (a, i) { return a + i.quantity; }, 0);
      var target = dir === 0 ? 0 : dir > 0 ? q + (q % 2 ? 1 : 2) : Math.max(0, q - (q % 2 ? 1 : 2));
      var updates = {};
      lines.forEach(function (l, n) { updates[l.key] = n === 0 ? target : 0; });
      return post('cart/update.js', { updates: updates });
    }).catch(function (err) { console.warn('[bf-promo] could not change BOGO quantity', err); })
      .then(getCart)
      .then(function (fresh) {
        store(BOGO_KEY, JSON.stringify(bogoQuantities(fresh, bogoMap()).qty));
        lastCart = fresh;
        return refreshCartUI(fresh).then(function () { renderBars(fresh); return sync(); });
      });
  }

  var removeAllId = null;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('cart-remove-button');
    if (!btn) return;
    var row = btn.closest('tr, .cart-item');
    var input = row && row.querySelector('[data-quantity-variant-id]');
    if (input) removeAllId = Number(input.getAttribute('data-quantity-variant-id'));
  }, true);

  function removeAllPass(cart) {
    var id = removeAllId;
    removeAllId = null;
    if (!id) return Promise.resolve(cart);
    var updates = {}, n = 0;
    cart.items.forEach(function (i) { if (i.variant_id === id && i.quantity > 0) { updates[i.key] = 0; n++; } });
    if (!n) return Promise.resolve(cart);
    return post('cart/update.js', { updates: updates }).then(getCart).then(function (fresh) {
      store(BOGO_KEY, JSON.stringify(bogoQuantities(fresh, bogoMap()).qty));
      return refreshCartUI(fresh).then(function () { return fresh; });
    }).catch(function () { return cart; });
  }

  function bogoPass(cart) {
    var map = bogoMap();
    var cur = bogoQuantities(cart, map);
    var fromCart = lastSource === 'cart-items';
    lastSource = '';
    if (!cfg.bogoAuto || !map) { store(BOGO_KEY, JSON.stringify(cur.qty)); return Promise.resolve({ cart: cart }); }
    var prev = readQty();
    var updates = {}, added = [], removed = 0;
    Object.keys(cur.qty).forEach(function (id) {
      var q = cur.qty[id], p = prev[id] || 0;
      if (q === p) return;
      var target;
      if (q > p) {
        target = fromCart
          ? q + (q % 2)                              // cart "+": one more pair
          : 2 * (Math.ceil(p / 2) + (q - p));        // added N paid bags: N free ones
      } else {
        if (!fromCart) return;
        target = q - (q % 2);                        // cart "-": one less pair (3+3 -> 2+2)
      }
      if (target === q) return;
      var l = cur.line[id];
      updates[l.key] = Math.max(0, l.quantity + (target - q));
      if (target > q) added.push({ b: map[id], n: target - q });
      else removed++;
    });
    if (!added.length && !removed) { store(BOGO_KEY, JSON.stringify(cur.qty)); return Promise.resolve({ cart: cart }); }
    return post('cart/update.js', { updates: updates })
      .then(getCart)
      .then(function (fresh) {
        store(BOGO_KEY, JSON.stringify(bogoQuantities(fresh, map).qty));
        if (!added.length) return { cart: fresh, changed: true };   // removed a pair: no popup
        var names = added.map(function (a) { return (a.n > 1 ? a.n + ' free ' : 'your free ') + bogoName(a.b); }).join(' and ');
        return { cart: fresh, changed: true, msg: { text: 'Buy 1 Get 1 Free! We added ' + names + ' to your cart.', also: true } };
      })
      .catch(function (err) {
        console.warn('[bf-promo] could not add free BOGO item (stock?)', err);
        store(BOGO_KEY, JSON.stringify(cur.qty));
        return { cart: cart };
      });
  }

  function popups(list) {
    return list.filter(Boolean).reduce(function (p, m) { return p.then(function () { return popup(m); }); }, Promise.resolve());
  }

  function renderBars(cart) {
    var bars = document.querySelectorAll('[data-bf-bar]');
    if (!cart) return;
    if (!bars.length) { renderUpsell(cart); return; }

    var week = activeWeek();
    var t = totals(cart);
    var giftAmt = cfg.countMode === 'after' ? t.after : t.before;
    var shipT = shipThresholdCents();
    var giftT = week ? toCents(week.threshold) : null;
    // Gift name in the cart bar: GIFT_SHORT at the top of this file, else the product name
    var gift = week ? esc((GIFT_SHORT[week.week] || week.giftTitle || 'gift')) : '';
    var giftInCart = week && cart.items.some(function (i) { return i.variant_id === week.variantId; });
    var where = cfg.country === 'US' ? 'free US shipping' : (cfg.country && cfg.country !== 'CA' ? 'free international shipping' : 'free shipping');
    var html = '';

    if (cart.item_count === 0) {
      bars.forEach(function (b) { b.innerHTML = ''; b.hidden = true; });
      renderUpsell(cart);
      return;
    }

    var shipLeft = shipT ? shipT - t.after : null;
    var giftLeft = giftT ? giftT - giftAmt : null;

    if (shipLeft !== null && giftLeft !== null && shipLeft > 0 && shipLeft === giftLeft) {
      // Same amount left for both: one combined message.
      html += line(100 * t.after / shipT, 'Add <strong>' + money(shipLeft) + '</strong> more for <strong>' + where + '</strong> + a <strong>free ' + gift + '</strong>', false);
    } else {
      if (giftLeft !== null) {
        if (giftLeft > 0) {
          html += line(100 * giftAmt / giftT, 'Add <strong>' + money(giftLeft) + '</strong> more to get a <strong>free ' + gift + '</strong>', false);
        } else if (giftInCart) {
          html += line(100, '✓ Your <strong>free ' + gift + '</strong> is in your cart', true);
        } else {
          html += line(100, '✓ You unlocked a <strong>free ' + gift + '</strong> <button type="button" class="bf-bar__readd link">Add it to my cart</button>', true);
        }
      }
      if (shipLeft !== null) {
        if (shipLeft > 0) {
          html += line(100 * t.after / shipT, 'Add <strong>' + money(shipLeft) + '</strong> more for <strong>' + where + '</strong>', false);
        } else {
          html += line(100, '✓ You unlocked <strong>' + where + '</strong>', true);
        }
      }
    }

    var bmap = bogoMap();
    if (bmap) {
      var bq = bogoQuantities(cart, bmap).qty;
      Object.keys(bq).forEach(function (id) {
        if (bq[id] % 2 === 1) {
          html += line(50, 'Buy 1 Get 1 Free: add 1 more <strong>' + esc(bogoName(bmap[id])) + '</strong> and it\'s free <button type="button" class="bf-bar__bogo link" data-variant="' + id + '">Add my free one</button>', false);
        }
      });
    }


    bars.forEach(function (b) { b.innerHTML = html; b.hidden = !html; });
    renderUpsell(cart);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.bf-bar__bogo');
    if (!b) return;
    b.disabled = true;
    post('cart/add.js', { items: [{ id: Number(b.getAttribute('data-variant')), quantity: 1 }] })
      .catch(function (err) { console.warn('[bf-promo] could not add free item', err); })
      .then(getCart)
      .then(function (fresh) {
        var map = bogoMap();
        store(BOGO_KEY, JSON.stringify(bogoQuantities(fresh, map).qty));
        return refreshCartUI(fresh).then(function () { lastCart = fresh; renderBars(fresh); sync(); });
      });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.bf-bar__readd')) return;
    store(DECLINE_KEY, null);
    sync();
  });

  /* ---------- "Also on BOGO this week" row (cart drawer + cart page) ---------- */
  // Follows the promo schedule: uses this campaign week's BOGO collection from theme settings.
  function upsellList(cart) {
    var w = campaignWeek();
    var wk = w ? cfg.weeks[w - 1] : null;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var seen = {}, list = [];
    ((wk && wk.bogo) || []).forEach(function (b) {
      if (!b || !b.id || !b.pid || seen[b.pid]) return;
      if (inCart[b.pid] || b.avail === false) return;
      seen[b.pid] = true; list.push(b);
    });
    return cart.item_count > 0 ? list : [];
  }
  function upsellHTML(list, title) {
    return '<p class="bf-upsell__title">' + title + '</p><div class="bf-upsell__list">' +
        list.map(function (b) {
          return '<div class="bf-upsell__item">' +
            (b.img ? '<a href="' + esc(b.url) + '" class="bf-upsell__img"><img src="' + esc(b.img) + '" width="56" height="56" loading="lazy" alt="' + esc(b.title) + '"></a>' : '') +
            '<div class="bf-upsell__info"><a href="' + esc(b.url) + '" class="bf-upsell__name">' + esc(b.title.split(' | ')[0]) + (b.size && b.title.split(' | ')[0].toLowerCase().indexOf(b.size.toLowerCase()) < 0 ? ' <span>' + esc(b.size) + '</span>' : '') + '</a>' +
            '<p class="bf-upsell__price"><b>2 for ' + money(b.price) + '</b> · 1 bag free</p></div>' +
            '<button type="button" class="bf-upsell__add" data-variant-id="' + b.id + '" aria-label="Add a ' + esc(b.title) + ' pair, 2 for ' + money(b.price) + '">+ Add pair</button></div>';
        }).join('') + '</div>';
  }
  function renderUpsell(cart) {
    if (!cart) return;
    if (activePop && activePop.isOpen()) activePop.update(null);
    var boxes = document.querySelectorAll('[data-bf-upsell]');
    if (!boxes.length) return;
    var list = upsellList(cart);
    var html = list.length ? upsellHTML(list, '<span>Add a pair</span> · also Buy 1 Get 1 Free') : '';
    boxes.forEach(function (b) { if (b.getAttribute('data-html') !== html) { b.innerHTML = html; b.setAttribute('data-html', html); } b.hidden = !html; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.bf-upsell__add');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.textContent = 'Adding…';
    lastSource = '';
    // Same path as any other add: add 1 paid bag, then sync() adds the free one and shows the popup.
    post('cart/add.js', { items: [{ id: Number(b.getAttribute('data-variant-id')), quantity: 1 }] })
      .catch(function (err) { console.warn('[bf-promo] could not add BOGO item', err); })
      .then(function () {
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bf-upsell' }); return; } } catch (x) {}
        sync();
      });
  });

  /* ---------- main: make the cart match the rules ---------- */

  function sync() {
    if (busy) { rerun = true; return Promise.resolve(); }
    busy = true;

    return getCart().then(removeAllPass).then(bogoPass).then(function (res) {
      var cart = res.cart;
      var bogoMsg = res.msg || null;
      var week = activeWeek();
      var t = totals(cart);
      var amt = cfg.countMode === 'after' ? t.after : t.before;
      var qualifies = !!week && amt >= toCents(week.threshold);
      var giftLines = cart.items.filter(isGift);
      var keep = week ? giftLines.filter(function (i) { return i.variant_id === week.variantId; })[0] : null;
      var hadGift = read(STATE_KEY);

      // The gift always comes back while the cart qualifies (customers can't remove it).
      var readding = qualifies && !keep && week && hadGift === String(week.variantId);
      var declined = false;

      var updates = {};
      var removedOldWeek = null;
      giftLines.forEach(function (i) {
        if (!qualifies || i !== keep) {
          updates[i.key] = 0;
          if (week && i.variant_id !== week.variantId) removedOldWeek = i;
        } else if (i.quantity > 1) {
          updates[i.key] = 1; // one gift per order
        }
      });

      var needAdd = qualifies && !keep && !declined;
      var removing = Object.keys(updates).length > 0;
      var lostGift = giftLines.length > 0 && !qualifies;

      var chain = Promise.resolve();
      if (removing) chain = chain.then(function () { return post('cart/update.js', { updates: updates }); });
      if (needAdd) {
        chain = chain.then(function () {
          return post('cart/add.js', { items: [{ id: week.variantId, quantity: 1, properties: { _bf_gift: 'Black Friday week ' + week.week } }] })
            .catch(function (err) { console.warn('[bf-promo] could not add gift (sold out?)', err); needAdd = false; });
        });
      }
      if (!removing && !needAdd) {
        store(STATE_KEY, keep ? week.variantId : null);
        lastCart = cart;
        if (res.changed) {
          var shown = popups([bogoMsg]);
          if (IS_CART_PAGE) return shown.then(function () { return refreshCartUI(cart); });
          return refreshCartUI(cart).then(function () { renderBars(cart); });
        }
        renderBars(cart);
        return;
      }

      return chain.then(getCart).then(function (fresh) {
        lastCart = fresh;
        var nowHas = week && fresh.items.some(function (i) { return i.variant_id === week.variantId; });
        store(STATE_KEY, nowHas ? week.variantId : null);

        var msg = null;
        if (needAdd && nowHas) {
          msg = removedOldWeek
            ? 'This week\'s free gift has changed. Your ' + (removedOldWeek.product_title || 'previous gift').replace(/^Free Gift\s*[–-]\s*/i, '') + ' was swapped for a free ' + week.giftTitle + '.'
            : readding
              ? 'Your free ' + week.giftTitle + ' comes with orders over ' + money(toCents(week.threshold)) + ', so we put it back in your cart.'
              : 'Your free ' + week.giftTitle + ' has been added to your cart!';
        } else if (lostGift) {
          var left = week ? toCents(week.threshold) - amt : 0;
          var shipT2 = shipThresholdCents();
          var needShip = shipT2 && t2after(fresh) < shipT2;
          msg = week
            ? {
                title: 'Your free gift is just ' + money(left) + ' away!',
                text: 'Add just ' + money(left) + ' more to your cart to unlock ' + (needShip ? 'free shipping and ' : '') + 'your complimentary ' + week.giftTitle + '.',
                cta: GIFT_CTA_TEXT,
                url: GIFT_CTA_URL
              }
            : 'The free gift promotion has ended, so the gift was removed from your cart.';
        }

        var show = popups([bogoMsg, msg]);
        if (IS_CART_PAGE) return show.then(function () { return refreshCartUI(fresh); });
        return refreshCartUI(fresh).then(function () { renderBars(fresh); });
      });
    }).catch(function (e) {
      console.warn('[bf-promo] sync failed', e);
    }).then(function () {
      busy = false;
      if (rerun) { rerun = false; sync(); }
    });
  }

  /* ---------- wiring ---------- */

  // Dawn publishes cartUpdate after add-to-cart, quantity change and remove.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        // Dawn's cart quantity box publishes source 'cart-items'; adds use 'product-form' etc.
        if (e && e.source) lastSource = e.source;
        setTimeout(sync, 50);
      });
    }
  } catch (e) { /* not Dawn pubsub: fall back to observer below */ }

  // Dawn replaces the drawer HTML after updates; re-fill any empty bar.
  var pending = null;
  // "Continue shopping" in the empty cart (drawer + cart page) goes to the Black Friday page
  // during the campaign. Dawn re-renders the cart, so this runs again after every change.
  function fixContinueLinks() {
    if (!campaignWeek()) return;
    document.querySelectorAll('cart-drawer .drawer__inner-empty a.button, .cart__warnings a.button, .title-wrapper-with-link a.underlined-link')
      .forEach(function (a) { if (a.getAttribute('href') !== GIFT_CTA_URL) a.setAttribute('href', GIFT_CTA_URL); });
  }
  fixContinueLinks();
  // Safety net: catch the click itself, so it works even if the page was opened before the sale started
  document.addEventListener('click', function (e) {
    var a = e.target.closest('cart-drawer a[href], cart-items a[href], .cart__warnings a[href], .title-wrapper-with-link a[href]');
    if (!a || !campaignWeek()) return;
    var path = (a.getAttribute('href') || '').split(/[?#]/)[0].replace(/\/$/, '');
    var isContinue = /\/collections\/all$/.test(path) || a.matches('.drawer__inner-empty a.button, .cart__warnings a.button, .title-wrapper-with-link a.underlined-link');
    if (!isContinue) return;
    e.preventDefault();
    window.location.href = GIFT_CTA_URL;
  }, true);

  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      fixContinueLinks();
      var empty = Array.prototype.some.call(document.querySelectorAll('[data-bf-bar]'), function (b) { return !b.innerHTML.trim(); });
      var emptyUp = Array.prototype.some.call(document.querySelectorAll('[data-bf-upsell]'), function (b) { return !b.hasAttribute('data-html'); });
      if ((empty || emptyUp) && lastCart) renderBars(lastCart);
    }, 30);
  }).observe(document.body, { childList: true, subtree: true });

  // Expose for testing in the browser console: bfPromo.sync()
  window.bfPromo = { sync: sync, config: cfg, activeWeek: activeWeek };

  sync();
})();
